import React from 'react';

/**
 * El fondo que se tiñe según el acto que se está mirando.
 *
 * Las cuatro capas están SIEMPRE montadas y se cruzan por opacidad — no se monta y desmonta la que
 * toca. Un crossfade necesita las dos capas vivas a la vez, y montar la entrante en el momento del
 * cambio da un salto en vez de una transición.
 *
 * Quién se enciende lo decide el CSS a partir de `data-step` en un ancestro (`.iab-flow-canvas`),
 * igual que en el escenario por-ruta: el JS sólo dice qué sección se ve, y el estilo hace el resto.
 *
 * Va pegada al viewport (`sticky`, alto 0) para que acompañe el scroll sin ocupar lugar en el
 * flujo. Ojo con el orden de pintado: el contenedor no puede tener fondo propio opaco por encima
 * de esta capa — en el mockup lo tenía y la aurora no se veía nunca.
 */
export function BoosterAurora() {
    return (
        <div className="iab-flow-aurora" aria-hidden="true">
            <i className="iab-au-alimenta"/>
            <i className="iab-au-revisa"/>
            <i className="iab-au-memoria"/>
            <i className="iab-au-usa"/>
        </div>
    );
}

export default BoosterAurora;
